import { useEffect, useState } from "react";
import { LeaderboardApi } from "../../../api/LeaderboardApi";
import RankingLeaderboard from "./RankingLeaderboard";

const HEADING = "STEAiM-in-PE 比賽";
const SUB_HEADING = "最活躍學校";

// Configurable refresh interval in milliseconds
const DEFAULT_REFRESH_INTERVAL = 2000;

export default function MostActiveSchoolLeaderboard({ refreshInterval = DEFAULT_REFRESH_INTERVAL, orgType="all", topRankCount = 3 }) {
    const [leaderboardData, setLeaderboardData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const orgTypeLabel = orgType === "primary" ? "小學" : orgType === "secondary" ? "中學" : "";

    useEffect(() => {
        loadLeaderboard();
        if (refreshInterval < 0) return;
        const timer = setInterval(loadLeaderboard, refreshInterval);
        return () => clearInterval(timer);
    }, [refreshInterval]);

    const loadLeaderboard = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const result = await LeaderboardApi.getTopOrgPlayTime(orgType);
            console.log("MostActiveSchoolLeaderboard result", result);
            const transformed = (result || []).map(
                ({ id, name_zh, name_en, code, rank, total_duration, format_total_duration }) => ({
                    id,
                    itemName: name_zh,
                    itemNameEn: name_en,
                    code,
                    rank,
                    score: total_duration,
                    scoreLabel: format_total_duration,
                })
            );
            setLeaderboardData(transformed.slice(0, topRankCount));
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    if (error) return null;

    return (
        <RankingLeaderboard
            heading={HEADING}
            subHeading={`${SUB_HEADING} (${orgTypeLabel})`}
            leaderboardData={leaderboardData}
            isLoading={isLoading}
        />
    );
}
